export default __webpack_public_path__ + "static/media/cheese.402c771e.png";